module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M12-clean-e159d2163e03923a8665b2811a3ae81e.png";